export function getCurrentlySelectedPatientIds(apiRef) {
  const selectedRows = apiRef.current?.getSelectedRows?.();
  return selectedRows ? Array.from(selectedRows.keys()) : [];
}

export function resolvePushToPreScreeningResult(data, selectedPatientIds) {
  const successfulIds = data?.successfulPatientIds || [];
  const failedIds = data?.failedPatientIds || [];
  const successCount = data?.successCount ?? successfulIds.length;
  const failureCount = data?.failureCount ?? failedIds.length;
  const successfulIdsSet = new Set(successfulIds);
  const selectedIdsSet = new Set(selectedPatientIds);

  return {
    failedIds,
    successCount,
    failureCount,
    nextSelectionModel: {
      type: 'include',
      ids: new Set([...selectedIdsSet].filter(id => !successfulIdsSet.has(id)))
    }
  };
}
